import React, { useEffect } from 'react'
import { getRedirectResult, OAuthCredential } from 'firebase/auth'
import { toast } from 'react-hot-toast'

// import { auth } from '@/config/firebase'
import { useSignInWithGoogle } from '@/domain/auth/useCases/useSignInWithGoogle'
import { useSignInWithApple } from '@/domain/auth/useCases/useSignInWithApple'
import { useUserAuthSessionStore, useProfileDraftStore } from '@/store'
import { useAuthScopedStore } from '@/store/scoped'

/**
 * Global Firebase OAuth redirect handler
 *
 * Intercepts return after Google/Apple OAuth authorization
 * and handles the result regardless of which page the user is on
 */
export const FirebaseAuthRedirectHandler: React.FC = () => {
  // Use store directly to avoid useNavigate() outside Router context
  const initializeSession = useUserAuthSessionStore(
    (state) => state.initializeSession,
  )
  const setDraft = useProfileDraftStore((state) => state.setDraft)
  const setIdentificationMethod = useAuthScopedStore(
    (state) => state.setIdentificationMethod,
  )

  // Google Sign In mutation
  const { mutateAsync: signInWithGoogle } = useSignInWithGoogle({
    onSuccess: async ({ access_token, refresh_token, next_step }) => {
      await initializeSession({
        token: access_token,
        refreshToken: refresh_token,
      })

      // Use window.location.href instead of navigate
      if (next_step === 'SETUP_PROFILE') {
        window.location.href = '/setup-profile'
      } else {
        window.location.href = '/dashboard'
      }
    },
    onError: ({ errorMessage }) => {
      toast.error(errorMessage || 'Google authentication failed')
    },
  })

  // Apple Sign In mutation
  const { mutateAsync: signInWithApple } = useSignInWithApple({
    onSuccess: async ({ access_token, refresh_token, next_step }) => {
      await initializeSession({
        token: access_token,
        refreshToken: refresh_token,
      })

      // Use window.location.href instead of navigate
      if (next_step === 'SETUP_PROFILE') {
        window.location.href = '/setup-profile'
      } else {
        window.location.href = '/dashboard'
      }
    },
    onError: ({ errorMessage }) => {
      toast.error(errorMessage || 'Apple authentication failed')
    },
  })

  useEffect(() => {
    const handleRedirectResult = async () => {
      try {
        // const result: any = await getRedirectResult(auth)

        // if (!result) {
        //   return
        // }

        // // Determine provider
        // const providerId = result.providerId

        // // Handle Google
        // if (providerId === 'google.com') {

        //   const oauthIdToken = result._tokenResponse?.oauthIdToken

        //   if (!oauthIdToken) {
        //     throw new Error('No Google OAuth ID token found')
        //   }

        //   // Extract profile data
        //   let avatarUrl = result.user.photoURL || ''
        //   if (avatarUrl) {
        //     avatarUrl = avatarUrl.replace(/=s\d+-c/, '=s400-c')
        //   }

        //   const profileData = {
        //     firstName: result.user.displayName?.split(' ')[0] || '',
        //     lastName:
        //       result.user.displayName?.split(' ').slice(1).join(' ') || '',
        //     email: result.user.email || '',
        //     avatar: avatarUrl,
        //   }

        //   setDraft(profileData)
        //   setIdentificationMethod('google')

        //   // Send to backend
        //   await signInWithGoogle({ id_token: oauthIdToken })
        // }
        // // Handle Apple
        // else if (providerId === 'apple.com') {

        //   const credential = OAuthCredential.fromJSON(
        //     result._tokenResponse,
        //   ) as OAuthCredential

        //   if (!credential || !credential.idToken) {
        //     throw new Error('No Apple OAuth ID token found')
        //   }

        //   const idToken = credential.idToken

        //   // Extract profile data
        //   const displayName = result.user.displayName || ''
        //   const email = result.user.email || ''

        //   const nameParts = displayName.split(' ')
        //   const firstName = nameParts[0] || ''
        //   const lastName = nameParts.slice(1).join(' ') || ''

        //   const profileData = {
        //     firstName,
        //     lastName,
        //     email,
        //     avatar: '', // Apple does not return an avatar
        //   }

        //   setDraft(profileData)
        //   setIdentificationMethod('apple')

        //   // Send to backend
        //   await signInWithApple({ id_token: idToken })
        // }
      } catch (error: any) {
        // Don't show error if user just closed the window
        if (
          error.code !== 'auth/popup-closed-by-user' &&
          error.code !== 'auth/cancelled-popup-request'
        ) {
          toast.error('Failed to complete authentication')
        }
      }
    }

    handleRedirectResult()
  }, [
    signInWithGoogle,
    signInWithApple,
    setDraft,
    setIdentificationMethod,
    initializeSession,
  ])

  return null // This component does not render UI
}
